import theme from '@src/theme/theme';

import { dFlex } from '@assets/mixins';

export const styleBox = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 670,
};

export const styleChildren = {
  background: theme.palette.custom.background.medium,
  padding: '24px',
  borderRadius: '8px',
};

export const styleClose = {
  display: 'flex',
  marginLeft: 'auto',
  color: theme.palette.custom.text.dark,
  width: 32,
  height: 32,
};

export const styleHeader = {
  ...dFlex('space-between'),
  paddingBottom: '24px',

  '> button': {
    marginLeft: 'auto',
  },
};

export const styleBackdrop = {
  '& .MuiModal-backdrop': {
    background: '#402C18B8',
  },
};
